const OnlinePayments = () => import("./views/OnlinePayments.vue");

export default [
  {
    path: "/onlinePayments",
    name: "onlinePayments.list",
    component: OnlinePayments,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
